import React, { useState, useEffect } from "react";
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { Row, Col, Card, Breadcrumb, Tabs, Tab, Table, Modal, Form } from 'react-bootstrap';
import { Dialog } from 'primereact/dialog';
import GifLoder from '../../components/GifLoder';
import { Button } from 'primereact/button';
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { IoChevronBackOutline } from "react-icons/io5";
import { Calendar } from 'primereact/calendar';
import { Badge } from 'primereact/badge';
import { Dropdown } from "primereact/dropdown";
import { TbStatusChange } from "react-icons/tb";
import { Tag } from 'primereact/tag';

const Client_Submitted_Form_list = () => {
    const { accessToken, role } = useAuth();
    const [loading, setLoading] = useState(true);
    const [formsData, setFormsData] = useState({
        Submitted: [],
        Work_Accepted: [],
        Work_Rejected: [],
        Cancelled: []
    });
    const [activeTab, setActiveTab] = useState("Submitted"); // Default tab
    const navigate = useNavigate();


    const [showDialog, setShowDialog] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [currentFormId, setCurrentFormId] = useState(null);
    const [currentFormType, setCurrentFormType] = useState(null);
    const [dialogStep, setDialogStep] = useState(1); // 1 = pick status, 2 = pick template
    const [availableTemplates, setAvailableTemplates] = useState([]);
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [loadingTemplates, setLoadingTemplates] = useState(false);
    const statusOptions = [
        { label: "Submitted", value: "Submitted" },
        { label: "Work Accepted", value: "Work_Accepted" },
        { label: "Work Rejected", value: "Work_Rejected" },
        { label: "Cancelled", value: "Cancelled" }
    ];

    const goBack = () => {
        navigate(-1); // This will take the user back to the previous page in history
    };

    /*---------------Month filter-------------------*/

    const currentDate = new Date();
    const [date, setDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));


    /*---------------Order history-------------------*/

    const [expandedRow, setExpandedRow] = useState(null);

    const toggleExpand = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };


    const [showEditModal, setShowEditModal] = useState(false);
    const [currentForm, setCurrentForm] = useState(null);
    const [updatedResponses, setUpdatedResponses] = useState([]);




    const fetchForms = async (selectedDate) => {
        try {
            setLoading(true);

            // Extract month and year from the selectedDate
            const month = selectedDate.getMonth() + 1; // Months are 0-indexed in JS
            const year = selectedDate.getFullYear();

            const response = await axios.get(
                `${config.apiBASEURL}/ClientFormRoutes/Admin-fetch-all-submitted-forms?month=${month}&year=${year}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );

            setFormsData(response.data);
        } catch (error) {
            console.error("Error fetching forms:", error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };


    useEffect(() => {
        fetchForms(date);
    }, [date, accessToken]);

    const getSeverity = (status) => {
        switch (status) {
            case 'Draft':
                return 'secondary'; // Grey
            case 'Submitted':
                return 'info'; // Blue
            case 'Work_Accepted':
                return 'success'; // Green
            case 'Work_Rejected':
                return 'danger'; // Red
            case 'Cancelled':
                return 'warning'; // Yellow
            default:
                return 'neutral';
        }
    };




    // Open edit dialog and populate form data
    const handleEditClick = (form) => {
        setCurrentForm(form);
        setUpdatedResponses(
            form.steps
                ? Object.values(form.steps).flatMap((sections) =>
                    Object.values(sections).flat()
                )
                : []
        );
        setShowEditModal(true);
    };

    const handleFieldChange = (form_data_id, value) => {
        setUpdatedResponses((prevResponses) =>
            prevResponses.map((field) =>
                field.form_data_id === form_data_id
                    ? {
                        ...field,
                        response: field.input_type === "date" && value instanceof Date
                            ? value.toISOString().split("T")[0] // Convert Date to "YYYY-MM-DD"
                            : value
                    }
                    : field
            )
        );
    };






    // Save form data
    const handleSave = async () => {
        if (!currentForm) return;
        setLoading(true);

        try {
            await axios.put(
                `${config.apiBASEURL}/ClientFormRoutes/form-submissions-admin/${currentForm.form_submission_id}/form-data`,
                { responses: updatedResponses },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            setShowEditModal(false);
            fetchForms(date);
        } catch (error) {
            console.error("Error updating form:", error);
        }
    };



    // Open the dialog & store the form ID + type
    const openDialog = (form) => {
        setCurrentFormId(form.form_submission_id);
        setCurrentFormType(form.type);
        setSelectedStatus(null);
        setSelectedTemplateId(null);
        setAvailableTemplates([]);
        setDialogStep(1);
        setShowDialog(true);
    };

    // When Work_Accepted is selected, fetch templates for that form type
    const handleStatusChange = async (value) => {
        setSelectedStatus(value);
        if (value === 'Work_Accepted' && currentFormType) {
            setLoadingTemplates(true);
            try {
                const res = await axios.get(
                    `${config.apiBASEURL}/ClientFormTaskTemplateRoutes/templates?form_type=${encodeURIComponent(currentFormType)}`,
                    { headers: { Authorization: `Bearer ${accessToken}` } }
                );
                const active = (res.data.templates || []).filter((t) => t.is_active);
                setAvailableTemplates(active);
                // Pre-select the default template if one exists
                const defaultTemplate = active.find((t) => t.is_default);
                if (defaultTemplate) setSelectedTemplateId(defaultTemplate.template_id);
            } catch (err) {
                console.error('Failed to load templates', err);
                setAvailableTemplates([]);
            } finally {
                setLoadingTemplates(false);
            }
        }
    };

    const goToTemplateStep = () => setDialogStep(2);
    const goBackToStatus = () => setDialogStep(1);

    const resetDialog = () => {
        setShowDialog(false);
        setSelectedStatus(null);
        setCurrentFormId(null);
        setCurrentFormType(null);
        setSelectedTemplateId(null);
        setAvailableTemplates([]);
        setDialogStep(1);
    };

    // Handle status submission
    const handleSubmitForm = async () => {
        if (!selectedStatus || !currentFormId) return;

        setLoading(true);
        try {
            const body = { status: selectedStatus };
            if (selectedStatus === 'Work_Accepted' && selectedTemplateId) {
                body.template_id = selectedTemplateId;
            }

            const response = await axios.put(
                `${config.apiBASEURL}/ClientFormRoutes/form-status-update/${currentFormId}/status`,
                body,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                if (response.data?.taskboard?.created) {
                    const { project_name, board_id, tasks_created } = response.data.taskboard;
                    const taskMsg = tasks_created
                        ? ` with ${tasks_created} task${tasks_created === 1 ? '' : 's'}`
                        : ' (no tasks — no template selected)';
                    setSuccessMessage(
                        `Taskboard created: ${project_name}${board_id ? ` (Board #${board_id})` : ''}${taskMsg}`
                    );
                    setShowSuccessDialog(true);
                }
                fetchForms(date);
                resetDialog();
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setLoading(false);
        }
    };


    /*--------------Status Tag---------------------*/

    const getStatusClass = (status) => {
        switch (status) {
            case 'Accepted':
                return 'success';  // Green
            case 'Work_under_progress':
                return 'info';  // Blue
            case 'Completed':
                return 'success';  // Green
            case 'On_Hold':
                return 'warning';  // Orange
            case 'Rejected':
                return 'danger';  // Red
            default:
                return 'secondary';  // Gray (default)
        }
    };


    const handleDownloadPDF = async (form) => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/ClientFormRoutes/form-submissions/${form.form_submission_id}/pdf`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            // ✅ Always open stored/generated URL
            window.open(response.data.pdfUrl, "_blank");
        } catch (error) {
            console.error("Error downloading PDF:", error);
        } finally {
            setLoading(false);
        }
    };




    if (loading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }




    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0'>
                    <Col md={6} lg={9} className='mb-4'>
                        <Breadcrumb>
                            <Breadcrumb.Item onClick={() => navigate(-1)}>
                                <IoChevronBackOutline /> Back
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Client Submitted Forms</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col lg={12} className="mb-4 p-0">
                        <Card>
                            <Card.Header className="d-flex justify-content-end align-items-center border-bottom-0">
                                <div className="d-flex justify-content-end align-items-center gap-2">
                                    <label>Filter by Month</label>
                                    <Calendar value={date} onChange={(e) => setDate(e.value)} view="month" dateFormat="mm/yy" style={{ width: '150px' }} />
                                </div>
                            </Card.Header>
                            <Card.Body className="pt-0">
                                <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
                                    {Object.entries(formsData).map(([status, forms]) => (
                                        <Tab
                                            eventKey={status}
                                            title={`${status.replace("_", " ")} (${forms.length})`}
                                            key={status}
                                        >
                                            {forms.length > 0 ? (
                                                <Table bordered responsive striped size="sm">
                                                    <thead>
                                                        <tr className="table-primary">
                                                            <th>#</th>
                                                            <th>Client</th>
                                                            <th>Form Name</th>
                                                            <th>Submission Date</th>
                                                            <th style={{ width: '140px' }}>Status</th>
                                                            <th style={{ width: '140px' }}>Payment Status</th>
                                                            <th style={{ width: '150px' }}>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {forms.map((form, index) => (
                                                            <React.Fragment key={form.form_submission_id}>
                                                                <tr>
                                                                    <td>{index + 1}</td>

                                                                    <td className="position-relative">
                                                                        {form.client?.Billing_name} &nbsp; <Badge className='bg-success' value={'Accepted'} />
                                                                        <div className="d-flex flex-column">
                                                                            <span className="text-muted">
                                                                                <small className="d-block">
                                                                                    <i className="pi pi-envelope me-1 text-warning" style={{ fontSize: '12px', verticalAlign: 'middle' }}></i> {form.client?.email}
                                                                                </small>
                                                                                <small>
                                                                                    <i className="pi pi-phone me-1 text-info" style={{ fontSize: '12px', verticalAlign: 'middle' }}></i> {form.client?.phone}
                                                                                </small>
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span className="text-black d-block">{form.form_name}</span>
                                                                        <small className="text-muted">{form.type}</small>
                                                                    </td>
                                                                    <td>{new Date(form.submission_date).toLocaleDateString('en-GB')}</td>
                                                                    <td>
                                                                        <Badge
                                                                            value={form.submission_status}
                                                                            severity={getSeverity(form.submission_status)}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <Tag
                                                                                value={'Payment_due'}
                                                                                severity={'danger'}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <Button
                                                                            title={expandedRow === index ? "Hide" : "View"}
                                                                            severity="help"
                                                                            text
                                                                            icon={expandedRow === index ? "pi pi-eye-slash" : "pi pi-eye"}
                                                                            className="p-0 me-2"
                                                                            onClick={() => toggleExpand(index)}
                                                                            tooltip='View'
                                                                            tooltipOptions={{ position: 'top' }}
                                                                        />
                                                                        {form.submission_status === "Submitted" && (
                                                                            <Button
                                                                                severity="danger"
                                                                                text
                                                                                icon="pi pi-file-pdf"
                                                                                className="p-0 me-2"
                                                                                onClick={() => handleDownloadPDF(form)}   // ✅ use new handler
                                                                                tooltip="Download PDF"
                                                                                tooltipOptions={{ position: 'top' }}
                                                                            />
                                                                        )}
                                                                        <Button
                                                                            //title="Edit"
                                                                            severity="info"
                                                                            text
                                                                            icon="pi pi-pencil"
                                                                            className="p-0 me-2"
                                                                            onClick={() => handleEditClick(form)}
                                                                            tooltip="Edit"
                                                                            tooltipOptions={{ position: 'top' }}
                                                                        />
                                                                        <Button
                                                                            key={form.form_submission_id}
                                                                            //title="Submit Form"
                                                                            severity="success"
                                                                            text
                                                                            className="p-0 me-2"
                                                                            onClick={() => openDialog(form)}
                                                                            tooltip="Submit Form"
                                                                            tooltipOptions={{ position: 'top' }}
                                                                        >
                                                                            <TbStatusChange size={26} />
                                                                        </Button>
                                                                        <Button
                                                                            //title="Link Project"
                                                                            icon="pi pi-link"
                                                                            className="py-1 me-2 border-0"
                                                                            severity="danger"
                                                                            outlined
                                                                            tooltip="Link Project"
                                                                            tooltipOptions={{ position: 'bottom' }}
                                                                        />
                                                                        <Button
                                                                            //title="Update Status"
                                                                            icon="pi pi-refresh"
                                                                            className="py-1 border-0"
                                                                            severity="help"
                                                                            outlined
                                                                            tooltip="Update Status"
                                                                            tooltipOptions={{ position: 'bottom' }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                {expandedRow === index && form.steps && typeof form.steps === "object" && (
                                                                    <tr className="table-light">
                                                                        <td colSpan="7">
                                                                            <div className="p-2">
                                                                                {Object.entries(form.steps).map(([_, sections]) => (
                                                                                    sections &&
                                                                                    typeof sections === "object" &&
                                                                                    Object.entries(sections).map(([section, fields]) => (
                                                                                        <div key={section} className="allempList mt-3">
                                                                                            <h6 className="rol-title">{section}</h6>
                                                                                            <ul>
                                                                                                {Array.isArray(fields) &&
                                                                                                    fields.map((field, i) => (
                                                                                                        <li key={i}>
                                                                                                            <small className="text-danger d-block">{field.field_label}:</small>{" "}
                                                                                                            {field.input_type === "date"
                                                                                                                ? new Date(field.response).toLocaleDateString("en-GB")
                                                                                                                : field.response}
                                                                                                        </li>
                                                                                                    ))}
                                                                                            </ul>
                                                                                        </div>
                                                                                    ))
                                                                                ))}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </React.Fragment>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <p>No {status.replace("_", " ")} Forms</p>
                                            )}
                                        </Tab>
                                    ))}
                                </Tabs>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {/* Edit Form Modal */}
                <Modal show={showEditModal} onHide={() => setShowEditModal(false)} backdrop="static" keyboard={false}>
                    <Modal.Header closeButton className="bg-info text-white">
                        <h5 className="mb-0">Edit Form</h5>
                    </Modal.Header>
                    <Modal.Body style={{ height: '70vh', overflowY: 'auto' }}>
                        {updatedResponses.length > 0 ? (
                            <Form>
                                <Row className="m-0">
                                    {updatedResponses.map((field) => (
                                        <Col lg={12} md={12} key={field.form_data_id} className="mb-2 px-1 form_edit_evnc">
                                            <label className="form-label">{field.field_label}</label>
                                            {/* Text Input */}
                                            {field.input_type === "text" && (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={field.response || ""}
                                                    onChange={(e) => handleFieldChange(field.form_data_id, e.target.value)}
                                                />
                                            )}

                                            {/* Date Input */}
                                            {field.input_type === "date" && (
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={
                                                        field.response && !isNaN(Date.parse(field.response))
                                                            ? field.response.split("T")[0]
                                                            : ""
                                                    }
                                                    onChange={(e) =>
                                                        handleFieldChange(field.form_data_id, e.target.value)
                                                    }
                                                    onClick={(e) => {
                                                        e.target.showPicker(); // Show calendar on every click
                                                    }}
                                                    onFocus={(e) => {
                                                        e.target.blur(); // Remove focus to reset behavior
                                                        setTimeout(() => e.target.focus(), 0); // Reapply focus to allow re-opening
                                                    }}
                                                />
                                            )}


                                            {/* Number Input */}
                                            {field.input_type === "number" && (
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={field.response || ""}
                                                    onChange={(e) => handleFieldChange(field.form_data_id, e.target.value)}
                                                />
                                            )}

                                            {/* Dropdown (Disabled) */}
                                            {field.input_type === "select" && (
                                                <select className="form-select" disabled>
                                                    <option value={field.response}>{field.response}</option>
                                                </select>
                                            )}

                                            {/* Textarea Input */}
                                            {field.input_type === "textarea" && (
                                                <textarea
                                                    className="form-control"
                                                    value={field.response || ""}
                                                    onChange={(e) => handleFieldChange(field.form_data_id, e.target.value)}
                                                    rows="3"
                                                />
                                            )}
                                        </Col>
                                    ))}
                                </Row>

                            </Form>
                        ) : (
                            <p>No fields available to edit.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="bg-light">
                        <Button
                            label="Cancel"
                            severity="secondary"
                            className="py-2"
                            onClick={() => setShowEditModal(false)}
                        />
                        <Button
                            label="Update"
                            severity="primary"
                            className="py-2"
                            onClick={handleSave}
                        />
                    </Modal.Footer>
                </Modal>

                <Dialog
                    header={dialogStep === 1 ? "Update Submission Status" : "Select a Task Template (optional)"}
                    visible={showDialog}
                    onHide={resetDialog}
                    modal
                    style={{ width: '480px' }}
                    footer={
                        dialogStep === 1 ? (
                            <div>
                                <Button label="Cancel" icon="pi pi-times" severity="danger" text onClick={resetDialog} />
                                {selectedStatus === 'Work_Accepted' ? (
                                    <Button
                                        label="Next: Pick template"
                                        icon="pi pi-arrow-right"
                                        iconPos="right"
                                        text
                                        severity="success"
                                        disabled={!selectedStatus}
                                        onClick={goToTemplateStep}
                                    />
                                ) : (
                                    <Button
                                        label="Confirm"
                                        icon="pi pi-check"
                                        text
                                        severity="success"
                                        disabled={!selectedStatus || loading}
                                        onClick={handleSubmitForm}
                                    />
                                )}
                            </div>
                        ) : (
                            <div>
                                <Button label="Back" icon="pi pi-arrow-left" severity="secondary" text onClick={goBackToStatus} />
                                <Button
                                    label={selectedTemplateId ? "Accept with template" : "Accept without tasks"}
                                    icon="pi pi-check"
                                    severity="success"
                                    text
                                    loading={loading}
                                    onClick={handleSubmitForm}
                                />
                            </div>
                        )
                    }
                >
                    {dialogStep === 1 && (
                        <div>
                            <label className="form-label">New status</label>
                            <Dropdown
                                value={selectedStatus}
                                options={statusOptions}
                                onChange={(e) => handleStatusChange(e.value)}
                                placeholder="Select Status"
                                className="w-100"
                            />
                        </div>
                    )}

                    {dialogStep === 2 && (
                        <div>
                            <p className="text-muted mb-3" style={{ fontSize: '13px' }}>
                                Pick a template to automatically create tasks on the board, or leave it blank and click "Accept without tasks".
                            </p>

                            {loadingTemplates ? (
                                <p><i className="pi pi-spin pi-spinner me-2" />Loading templates…</p>
                            ) : availableTemplates.length === 0 ? (
                                <p className="text-muted">No active templates found for type <strong>{currentFormType}</strong>. The board will be created without tasks.</p>
                            ) : (
                                <div>
                                    <label className="form-label">Select template</label>
                                    <Dropdown
                                        value={selectedTemplateId}
                                        options={availableTemplates.map((t) => ({
                                            label: `${t.template_name}${t.is_default ? ' ★' : ''} (${t.task_count} task${t.task_count !== 1 ? 's' : ''})`,
                                            value: t.template_id,
                                            notes: t.notes,
                                            is_default: t.is_default,
                                        }))}
                                        onChange={(e) => setSelectedTemplateId(e.value)}
                                        placeholder="— No template (create board only) —"
                                        className="w-100"
                                        showClear
                                        itemTemplate={(option) => (
                                            <div>
                                                <div><strong>{option.label}</strong></div>
                                                {option.notes && <div className="text-muted" style={{ fontSize: '12px' }}>{option.notes}</div>}
                                            </div>
                                        )}
                                    />
                                    {selectedTemplateId && (
                                        <small className="text-success mt-2 d-block">
                                            <i className="pi pi-check-circle me-1" />
                                            Tasks from this template will be added to the board on accept.
                                        </small>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </Dialog>

                <Dialog
                    header="Taskboard Created"
                    visible={showSuccessDialog}
                    onHide={() => setShowSuccessDialog(false)}
                    modal
                    style={{ width: '460px' }}
                    footer={
                        <Button
                            label="OK"
                            icon="pi pi-check"
                            severity="success"
                            onClick={() => setShowSuccessDialog(false)}
                        />
                    }
                >
                    <p className="mb-0">{successMessage}</p>
                </Dialog>

            </Row>
        </>
    );
};
export default Client_Submitted_Form_list;
